export const participationType = ["FULL_TIME", "PART_TIME", "NA", "CONTRACT_BASIS"];
